/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from "vue";
import Router from "vue-router";

// Routes
import default_route from "./routes";
import login_route from "./login";
import logout_route from "./nolayout";
// import Store from '@/store';
import ApiService from "@/services/ApiService";

Vue.use(Router);

// Create a new router
const router = new Router({
  mode: "history",
  routes: default_route.concat(login_route).concat(logout_route),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
  linkExactActiveClass: "nav-item active"
});

router.beforeEach(async (to, from, next) => {
  // console.log("1");
  // console.log(to.name);
  if (to.name === "login" || to.name === "logout") {
    // console.log("3");
    await ApiService.logout().catch(errors => {
      console.log("ERROR ", errors);
    });
    // console.log("4");
    return next();
  }
  if (!sessionStorage.userdata) {
    return next("/login");
  }
  // console.log("3");
  return next();
});

export default router;
